import * as tslib_1 from "tslib";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import cx from 'classnames';
import "./Paginate.css";

var Paginate =
/** @class */
function (_super) {
  tslib_1.__extends(Paginate, _super);

  function Paginate() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getBaseArrowClassName = function () {
      return _this.props.blockName + "__navigate";
    };

    _this.getHiddenClassName = function () {
      return _this.props.blockName + "__hidden";
    };

    _this.getPreviousClassName = function () {
      var forcePage = _this.props.forcePage;
      var additionalClassNames = '';

      if (forcePage === 0 || !_this.isBreakLabelShown()) {
        additionalClassNames += _this.getHiddenClassName();
      }

      return _this.getBaseArrowClassName() + " " + additionalClassNames;
    };

    _this.getNextClassName = function () {
      var _a = _this.props,
          forcePage = _a.forcePage,
          pageCount = _a.pageCount;
      var additionalClassNames = '';

      if (forcePage === pageCount - 1 || !_this.isBreakLabelShown()) {
        additionalClassNames += _this.getHiddenClassName();
      }

      return _this.getBaseArrowClassName() + " " + additionalClassNames;
    };

    _this.isBreakLabelShown = function () {
      return _this.props.pageCount >= 4;
    };

    return _this;
  }

  Paginate.prototype.render = function () {
    var _a = this.props,
        blockName = _a.blockName,
        pageCount = _a.pageCount,
        onPageChange = _a.onPageChange,
        forcePage = _a.forcePage,
        className = _a.className;

    if (!pageCount) {
      return null;
    }

    var previousLabel = React.createElement("i", {
      title: "Previous page",
      className: blockName + "__arrow icon-custom-page-prev"
    });
    var nextLabel = React.createElement("i", {
      title: "Next page",
      className: blockName + "__arrow icon-custom-page-next"
    });
    var breakLabel = React.createElement("i", {
      className: blockName + "__break icon-custom-options"
    });
    return React.createElement(ReactPaginate, {
      forcePage: forcePage,
      containerClassName: cx(blockName, className),
      previousLabel: previousLabel,
      nextLabel: nextLabel,
      breakLabel: breakLabel,
      breakClassName: blockName + "__break",
      pageCount: pageCount,
      previousLinkClassName: this.getPreviousClassName(),
      nextLinkClassName: this.getNextClassName(),
      pageClassName: blockName + "__page",
      pageLinkClassName: blockName + "__link",
      marginPagesDisplayed: 1,
      pageRangeDisplayed: 2,
      onPageChange: onPageChange,
      //@ts-ignore
      subContainerClassName: "pages pagination",
      activeClassName: blockName + "__page--active"
    });
  };

  Paginate.propTypes = {
    blockName: PropTypes.string,
    className: PropTypes.string,
    pageCount: PropTypes.number,
    forcePage: PropTypes.number,
    onPageChange: PropTypes.func
  };
  Paginate.defaultProps = {
    blockName: 'nx-paginate'
  };
  return Paginate;
}(PureComponent);

export default Paginate;

try {
  // @ts-ignore
  Paginate.__docgenInfo = {
    "description": "",
    "displayName": "Paginate",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "blockName": {
        "defaultValue": {
          value: "nx-paginate"
        },
        "description": "",
        "name": "blockName",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "forcePage": {
        "defaultValue": null,
        "description": "",
        "name": "forcePage",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      },
      "pageCount": {
        "defaultValue": null,
        "description": "",
        "name": "pageCount",
        "required": true,
        "type": {
          "name": "number"
        }
      },
      "onPageChange": {
        "defaultValue": null,
        "description": "",
        "name": "onPageChange",
        "required": true,
        "type": {
          "name": "((selectedItem: { selected: number; }) => void) | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}